(function () {
  function hkParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Hong_Kong',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var out = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') out[part.type] = part.value;
    });
    return out;
  }

  function updateLift(root) {
    var clock = root.querySelector('[data-lift-clock]');
    var primary = root.querySelector('[data-lift-primary]');
    var sub = root.querySelector('[data-lift-sub]');
    var live = root.querySelector('[data-lift-live]');
    if (!primary || !sub) return;

    var now;
    try {
      now = hkParts(new Date());
    } catch (error) {
      return;
    }
    var hour = parseInt(now.hour, 10);
    if (!now.hour || isNaN(hour)) return;
    var cargo = now.weekday === 'Sun' || hour >= 20;

    if (clock && now.hour && now.minute) {
      clock.textContent = '香港時間 ' + now.hour + ':' + now.minute;
    }

    if (live) live.setAttribute('data-state', cargo ? 'cargo' : 'passenger');

    if (cargo) {
      primary.textContent = '建議搭貨𨋢 5、6、7、12、13 號';
      sub.textContent = now.weekday === 'Sun'
        ? '今日星期日，請到貨𨋢大堂直上 12 樓。'
        : '已過 20:00，請到貨𨋢大堂直上 12 樓。';
    } else {
      primary.textContent = '建議搭客𨋢上 12 樓';
      sub.textContent = '白田壩街正門，或大廈與南豐紗廠之間的行人步道。';
    }
  }

  function showRoute(root, id) {
    var tabs = root.querySelectorAll('[data-route-tab]');
    var panels = root.querySelectorAll('[data-route-panel]');
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-route-tab') === id;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-route-panel') !== id;
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.left = '-9999px';
      document.body.appendChild(area);
      area.select();
      try {
        if (document.execCommand('copy')) resolve();
        else reject(new Error('copy failed'));
      } catch (error) {
        reject(error);
      } finally {
        area.remove();
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.cdReady === 'true') return;
    root.dataset.cdReady = 'true';
    root.classList.add('is-ready');

    var tabs = root.querySelectorAll('[data-route-tab]');
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        showRoute(root, tab.getAttribute('data-route-tab'));
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var next = event.key === 'ArrowRight'
          ? (index + 1) % tabs.length
          : (index - 1 + tabs.length) % tabs.length;
        tabs[next].focus();
        showRoute(root, tabs[next].getAttribute('data-route-tab'));
      });
    });
    showRoute(root, 'tsuenwan');

    var toast = root.querySelector('[data-toast]');
    var toastMessage = root.querySelector('[data-toast-message]');
    var toastTimer;
    root.querySelectorAll('[data-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var text = button.getAttribute('data-copy') || '';
        var message = button.getAttribute('data-copy-message') || '已複製';
        copyText(text).then(function () {
          if (!toast || !toastMessage) return;
          toastMessage.textContent = message;
          toast.hidden = false;
          clearTimeout(toastTimer);
          toastTimer = setTimeout(function () {
            toast.hidden = true;
          }, 2600);
        }).catch(function () {
          if (!toast || !toastMessage) return;
          toastMessage.textContent = '請手動選取文字複製';
          toast.hidden = false;
        });
      });
    });

    updateLift(root);
    fitLines(root);
    bindMap(root);
    root._cdTimer = setInterval(function () {
      updateLift(root);
    }, 60000);
  }

  function bindMap(root) {
    var openBtn = root.querySelector('[data-map-open]');
    var lightbox = root.querySelector('[data-map-lightbox]');
    if (!openBtn || !lightbox) return;
    var closeBtn = lightbox.querySelector('.cd-lightbox__close');

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      openBtn.focus();
    }

    function open() {
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    openBtn.addEventListener('click', open);
    lightbox.querySelectorAll('[data-map-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) close();
    });
  }

  function fitLines(root) {
    root.querySelectorAll('[data-fit-line]').forEach(function (line) {
      var inner = line.firstElementChild;
      if (!inner) return;
      inner.style.transform = '';
      line.style.height = '';
      var available = line.clientWidth;
      var needed = inner.scrollWidth;
      if (!available || !needed || needed <= available) return;
      var scale = available / needed;
      inner.style.transform = 'scale(' + scale + ')';
      line.style.height = Math.ceil(inner.offsetHeight * scale) + 'px';
    });
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-contact-directions]').forEach(init);
    if (scope && scope.matches && scope.matches('[data-contact-directions]')) init(scope);
  }

  var fitTimer;
  function refit() {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () {
      document.querySelectorAll('[data-contact-directions]').forEach(fitLines);
    }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }
  window.addEventListener('load', refit);
  window.addEventListener('resize', refit);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-contact-directions]')
      : null;
    if (root) root.dataset.cdReady = '';
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-contact-directions]')
      : null;
    if (root && root._cdTimer) clearInterval(root._cdTimer);
  });
})();
